module.exports = __webpack_public_path__ + "img/logo.9b9399f2.svg";